import { SessionChange, MagicConfigMixin, ModalMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __spreadArray, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { COREX_LIMITS_UPDATED, ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';
import { getUserTransactionLimits, getMaxWagerLimits, getUserSessionLimits } from '../../../utils/limits.js';

var unconfirmedLimitStatus = 'PendingUserAction';
/**
 * The Limit Confirmation Prompter periodically (on login) checks for
 * limits that must be confirmed by the user. When limits are required
 * to be confirmed it will open the specified modal with the list of limits.
 */
var ConfirmationPrompterComponent = /** @class */ (function (_super) {
    __extends(ConfirmationPrompterComponent, _super);
    function ConfirmationPrompterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        return _this;
    }
    ConfirmationPrompterComponent.prototype.render = function () {
        return null;
    };
    ConfirmationPrompterComponent.prototype.sessionChange = function (isLoggedIn) {
        if (isLoggedIn) {
            this.fetchLimits();
            return;
        }
        this.closeModal();
    };
    ConfirmationPrompterComponent.prototype.fetchLimits = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isPepBlocked, now, _a, userlimits, maxWagerLimits, sessionLimits, awaiting, modalElement;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY)];
                    case 1:
                        isPepBlocked = _b.sent();
                        now = new Date();
                        if (isPepBlocked) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Promise.all([
                                getUserTransactionLimits(),
                                getMaxWagerLimits(),
                                getUserSessionLimits(),
                            ])];
                    case 2:
                        _a = _b.sent(), userlimits = _a[0], maxWagerLimits = _a[1], sessionLimits = _a[2];
                        this.limits = __spreadArray(__spreadArray(__spreadArray([], userlimits), maxWagerLimits), sessionLimits);
                        window.eventBus.publish(COREX_LIMITS_UPDATED, this.limits);
                        awaiting = this.limits.filter(function (limit) {
                            var isUnconfirmed = limit.activationStatus === unconfirmedLimitStatus;
                            if (limit.pendingChangeExpectedOn) {
                                var pendingDate = new Date(limit.pendingChangeExpectedOn);
                                return isUnconfirmed && now >= pendingDate;
                            }
                            return isUnconfirmed;
                        });
                        if (awaiting.length > 0 && !this.hasModal()) {
                            modalElement = this.openModal(this.renderedModal, this.header || null, {
                                dismissible: false,
                                keepAfterClear: true,
                            });
                            modalElement.addEventListener('confirmed', function () {
                                _this.closeModal();
                            });
                            modalElement.unconfirmedLimits = awaiting;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({
            type: String,
            default: 'magic-corex-limit-confirmation-prompt',
        }),
        __metadata("design:type", String)
    ], ConfirmationPrompterComponent.prototype, "renderedModal", void 0);
    __decorate([
        Prop({
            type: String,
            default: null,
        }),
        __metadata("design:type", Object)
    ], ConfirmationPrompterComponent.prototype, "header", void 0);
    __decorate([
        SessionChange({ immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ConfirmationPrompterComponent.prototype, "sessionChange", null);
    ConfirmationPrompterComponent = __decorate([
        Component({
            name: 'corex-limit-confirmation-prompter',
        })
    ], ConfirmationPrompterComponent);
    return ConfirmationPrompterComponent;
}(Mixins(MagicConfigMixin, ModalMixin)));

export default ConfirmationPrompterComponent;
